"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageJJSC = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var layout_1 = require("./shared/layout");
var tab2_1 = require("./shared/tab2");
var middle_1 = require("../quotetable/middle");
/**
 * 基金市场
 */
function PageJJSC() {
    return (react_1.default.createElement("div", { className: "pagejjsc" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout3, { mt: 5 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000011", height: 162, width: 324, link: true }, "\u6CAA\u5E02\u57FA\u91D1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399306", height: 162, width: 324, link: true }, "\u6DF1\u5E02\u57FA\u91D1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.159915", height: 162, width: 324, link: true }, "\u521B\u4E1A\u677FETF"))),
        react_1.default.createElement(JJ_Tabbox1, null),
        react_1.default.createElement(JJ_Tabbox2, null),
        react_1.default.createElement(JJ_Tabbox3, null)));
}
exports.PageJJSC = PageJJSC;
/**
 * 封基行情涨/跌幅榜
 * @returns
 */
function JJ_Tabbox1() {
    return (react_1.default.createElement("div", { className: "tab_box" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "\u5C01\u57FA\u884C\u60C5\u6DA8\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_close_end" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:19", orderdur: 1 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html#fund_close_end" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u5C01\u57FA\u884C\u60C5\u6DA8\u5E45\u699C>>"))
                },
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "\u5C01\u57FA\u884C\u60C5\u8DCC\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_close_end" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:19", orderdur: 0 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html?sr=0#fund_close_end" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u5C01\u57FA\u884C\u60C5\u8DCC\u5E45\u699C>>"))
                }
            ] })));
}
/**
 * ETF行情涨/跌幅榜
 * @returns
 */
function JJ_Tabbox2() {
    return (react_1.default.createElement("div", { className: "tab_box" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "ETF\u884C\u60C5\u6DA8\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_etf" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:16", orderdur: 1 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html#fund_etf" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8ETF\u884C\u60C5\u6DA8\u5E45\u699C>>"))
                },
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "ETF\u884C\u60C5\u8DCC\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_etf" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:16", orderdur: 0 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html?sr=0#fund_etf" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8ETF\u884C\u60C5\u8DCC\u5E45\u699C>>"))
                }
            ] })));
}
/**
 * LOF行情涨/跌幅榜
 * @returns
 */
function JJ_Tabbox3() {
    return (react_1.default.createElement("div", { className: "tab_box" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "LOF\u884C\u60C5\u6DA8\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_lof" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:17", orderdur: 1 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html#fund_lof" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8LOF\u884C\u60C5\u6DA8\u5E45\u699C>>"))
                },
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "LOF\u884C\u60C5\u8DCC\u5E45\u699C"),
                    more: react_1.default.createElement("a", { href: "./gridlist.html#fund_lof" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement(JJ_HOMETable, { fs: "e:17", orderdur: 0 }),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "./gridlist.html?sr=0#fund_lof" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8LOF\u884C\u60C5\u8DCC\u5E45\u699C>>"))
                }
            ] })));
}
/**
 * 基金首页table
 * @param props
 * @returns
 */
function JJ_HOMETable(props) {
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: props.fs,
            count: 5,
            table_key: 'JJSCCOMMON',
            order: 'f3',
            orderdur: props.orderdur })));
}
